<template>
 <input-select :options="options" :label="label" @change="setValue" :value="model" required>
    <template v-slot:item="{ item }">
      <v-radio-group :value="model">
        <v-radio
          :label="item.text"
          color="primary"
          :value="item.value"
        >
        </v-radio>
      </v-radio-group>
    </template>
  </input-select>
</template>
<script>
export default {
  props: {
    value: null,
    options: [],
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    setValue (value) {
      this.$set(this, 'model', value)
    }
  },

}
</script>
